import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import locale from 'locale';
import {embedSettings, yandexMetricaGoals} from './models';
import {LinkContainer} from 'react-router-bootstrap';
import {Breadcrumb, Row, Col, ControlLabel} from 'react-bootstrap';
import * as constants from './constants';
import { FONT } from '../constants';
import RegistrationPreview from './RegistrationPreview';
import RegistrationEmbedCode from './RegistrationEmbedCode';
import RegistrationThemeSettings from './Settings/RegistrationThemeSettings';
import RegistrationLogoToggle from './Settings/RegistrationLogoToggle';
import RegistrationFontSetting from './Settings/RegistrationFontSetting';
import RegistrationCustomText from './Settings/RegistrationCustomText';
import RegistrationCalendarToggle from './Settings/RegistrationCalendarToggle';
import RegistrationTitleToggle from './Settings/RegistrationTitleToggle';
import RegistrationButtonSettings from './Settings/RegistrationButtonTitle';
import YandexMetricaTable from './YandexMetrica';
import WidgetLanguageSetting from '../components/Settings/WidgetLanguageSetting';
  
import './style.scss';
import RegistrationLabelsToggle from './Settings/RegistrationLabelsToggle';
import RegistrationPlaceholdersToggle from './Settings/RegistrationPlaceholderToggle';

const WidgetRegistration = ({event}) => { 
    const [isCustomSettingsUpdated, setCustomSettingsUpdated] = useState(false);
    const [isFormVisible, setFormVisible] = useState(true);
    const {accessPreModeration} = event.moduleAuth;
    const [widgetSettings, setWidgetSettings] = useState(() => {
        const localWidgetSettings = localStorage.getItem('widgetSettings');

        try {
            return localWidgetSettings ? JSON.parse(localWidgetSettings) : embedSettings;
        } catch (error) {
            console.error(error);
        }
    });
    
    useEffect(() => {
        localStorage.setItem('widgetSettings', JSON.stringify(widgetSettings));
    }, [widgetSettings]);

    function handleSettingsChange(key, value) {
        setWidgetSettings({...widgetSettings, [key]: value});
    }

    return event
        ? (
            <section className='widget-registration'>
                <Row>
                    <Breadcrumb>
                        <LinkContainer to={`/event/${event.eventPassword}`}>
                            <Breadcrumb.Item>
                                {locale('mainMenu.widgets')}
                            </Breadcrumb.Item>
                        </LinkContainer>
                        <Breadcrumb.Item active> 
                            {locale('mainMenu.widget.registration')}
                        </Breadcrumb.Item>
                    </Breadcrumb>
                </Row>
                <Row>
                    <Col xs={4}>
                        <WidgetLanguageSetting
                            lang={widgetSettings[constants.LANGUAGE]}
                            onUpdate={handleSettingsChange}
                        />
                        <RegistrationThemeSettings
                            widgetTheme={widgetSettings.style}
                            eventTheme={event.moduleTheme}
                            onUpdate={handleSettingsChange}
                        />
                        <RegistrationFontSetting
                            font={widgetSettings[FONT]}
                            onUpdate={handleSettingsChange}
                        />
                        <ControlLabel>Выбрать:</ControlLabel>
                        <p>
                            <span
                                className={`widget-registration__breadcrumb-item ${isFormVisible ? 'active' : ''}`}
                                onClick={() => setFormVisible(true)}
                            >
                                Настройки первого экрана / 
                            </span>
                            <span
                                className={`widget-registration__breadcrumb-item ${!isFormVisible ? 'active' : ''}`}
                                onClick={() => setFormVisible(false)}
                            >
                                Настройки второго экрана
                            </span>
                        </p>
                        {isFormVisible
                            ? <>
                                <RegistrationTitleToggle
                                    isTitleHidden={widgetSettings[constants.IS_REGISTRATION_TITLE_HIDDEN]}
                                    onUpdate={handleSettingsChange}
                                    onUpdateSetting={setCustomSettingsUpdated}
                                />
                                <RegistrationLabelsToggle
                                    isLabelsHidden={widgetSettings[constants.IS_LABELS_HIDDEN]}
                                    onUpdate={handleSettingsChange}
                                />
                                <RegistrationPlaceholdersToggle
                                    isPlaceholdersVisible={widgetSettings[constants.IS_PLACEHOLDERS_VISIBLE]}
                                    onUpdate={handleSettingsChange}
                                />
                                <RegistrationCustomText
                                    key="registrationText"
                                    eventWidget={event.moduleWidget}
                                    title="Добавить текст/описание"
                                    name={constants.IS_REGISTRATION_TEXT_HIDDEN}
                                    property="registrationText"
                                    isCustomTextHidden={widgetSettings[constants.IS_REGISTRATION_TEXT_HIDDEN]}
                                    onUpdate={handleSettingsChange}
                                    onUpdateSetting={setCustomSettingsUpdated}
                                />
                                <RegistrationButtonSettings
                                    eventWidget={event.moduleWidget}
                                    onUpdateSetting={setCustomSettingsUpdated}
                                />
                                <RegistrationLogoToggle
                                    isLogoHidden={widgetSettings[constants.IS_LOGO_HIDDEN]}
                                    onUpdate={handleSettingsChange}
                                />
                                <YandexMetricaTable 
                                    data={yandexMetricaGoals}
                                />
                            </>
                            : <>
                                <p>На этом мероприятии {accessPreModeration ? 'включена премодерация доступа' : 'премодерация доступа отключена'}</p>
                                <RegistrationCustomText
                                    key="confirmationTitle"
                                    eventWidget={event.moduleWidget}
                                    title="Изменить Заголовок"
                                    name={constants.IS_CONFIRMATION_TITLE_HIDDEN}
                                    property="confirmationTitle"
                                    row={2}
                                    defaultValue={constants.DEFAULT_CONFIRMATION_TITLE(accessPreModeration, event.name_ru)}
                                    isCustomTextHidden={widgetSettings[constants.IS_CONFIRMATION_TITLE_HIDDEN]}
                                    onUpdate={handleSettingsChange}
                                    onUpdateSetting={setCustomSettingsUpdated} 
                                />
                                <RegistrationCustomText
                                    key="confirmationText"
                                    eventWidget={event.moduleWidget}
                                    title="Изменить Текст/описание"
                                    name={constants.IS_CONFIRMATION_TEXT_HIDDEN}
                                    property="confirmationText"
                                    defaultValue={constants.DEFAULT_CONFIRMATION_TEXT(accessPreModeration)}
                                    isCustomTextHidden={widgetSettings[constants.IS_CONFIRMATION_TEXT_HIDDEN]}
                                    onUpdate={handleSettingsChange}
                                    onUpdateSetting={setCustomSettingsUpdated} 
                                />
                                <RegistrationCalendarToggle
                                    isCalendarVisible={widgetSettings[constants.IS_CALENDAR_VISIBLE]}
                                    onUpdate={handleSettingsChange}
                                />
                            </>
                        }
                    </Col>
                    <Col xs={8}>
                        <RegistrationEmbedCode
                            eventKey={event.eventKey}
                            settings={widgetSettings}
                        />
                        {!isCustomSettingsUpdated &&
                            <RegistrationPreview
                                event={event}
                                settings={{...widgetSettings, [constants.IS_FORM_VISIBLE]: isFormVisible}}
                                isFormVisible={isFormVisible}
                            />
                        }
                    </Col>
                </Row>
            </section>
        )
        : (<></>)
};

const mapStateToProps = (store) => {
	return {
		event: store.currentEvent
	};
};

export default connect(mapStateToProps)(WidgetRegistration);
